import gql from 'graphql-tag';

export default gql`
mutation addPageVersion(
  $pageId: Int!,
  $versionNumber: Int!,
  $editorData: jsonb!,
  $displayData: jsonb!,
  $userId: Int!
) {
  insert_page_versions(objects: [{
    page_id: $pageId,
    version_number: $versionNumber,
    editor_data: $editorData,
    display_data: $displayData,
    published: false,
    user_id: $userId
  }]) {
    affected_rows
    returning {
      page_version_id
    }
  }
}
`;
